/**
 * `contracts/screens.md` § Profile settings (2026-10-03, by the owner's approval of the product review,
 * which found the account pages in "a different shell with the 'Back to your team' row you rejected"):
 * the person's own pages are Team settings pages inside a Team, at `/{ws}/settings/account-{page}` under
 * the settings sidebar's Account section, as the instance's administration pages are `instance-{page}`
 * there (2026-09-18). `/settings/{page}` stays the address every email and Teams message links to: it
 * opens the same page in the Team the person was last in, and draws the frame of its own only for a
 * person in no Team.
 */
export const ACCOUNT_PAGES = ["profile", "security", "tokens", "notifications", "preferences"] as const;
export type AccountPage = (typeof ACCOUNT_PAGES)[number];

/** The prefix an account page's Team settings address carries, beside the instance pages' `instance-`. */
export const ACCOUNT_PAGE_PREFIX = "account-";

export function isAccountPage(value: string): value is AccountPage {
  return (ACCOUNT_PAGES as readonly string[]).includes(value);
}

/** An account page's address: inside the Team `ws`, or the Team-less frame's when the person is in none. */
export function accountSettingsPath(ws: string | null, page: AccountPage): string {
  return ws === null ? `/settings/${page}` : `/${ws}/settings/${ACCOUNT_PAGE_PREFIX}${page}`;
}
